"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M21.989 12.48c.007-.155.008-.162 0 0Zm-7.767 9.282a9.04 9.04 0 0 0 .103-.024c.002 0-.003 0 0 0l-.103.024Zm7.717-8.644Z",
      clipRule: "evenodd"
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M14.638 21.658a10.001 10.001 0 0 0 7.348-9.13l.001-.015.002-.034C22.25 6.861 17.635 2 12 2 6.353 2 1.733 6.893 2.013 12.51a9.986 9.986 0 0 0 2.705 6.348c2.502 2.662 6.398 3.759 9.92 2.8Zm-9.517-4.657A8.487 8.487 0 0 0 12 20.509a8.492 8.492 0 0 0 7.13-3.872 7.506 7.506 0 0 0-14.01.364Zm4.387-8.604a2.69 2.69 0 1 1 5.378-.002 2.69 2.69 0 0 1-5.378.002Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};